// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"CareersStyle_DictionaryContainer__SoRwI","customTitleh1":"CareersStyle_customTitleh1__v3mJZ"};